<template>
    <div>
        <div class="table-box">
            <div class="search-box">
                <Button type="primary" @click="createConfirm">创建社区竞赛</Button>
                <Select v-model="queryParams.status"
                        style="width:200px;margin-left: 10px"
                        placeholder="请选择竞赛状态"
                        clearable
                >
                    <Option value="1" >保存</Option>
                    <Option value="3" >已发布</Option>
                    <Option value="4" >比赛结束</Option>
                    <Option value="5" >审阅结束</Option>
                </Select>
                <DatePicker
                    class="ivu-select"
                    v-model="searchDate"
                    type="date"
                    value-type="YYYY-MM-DD"
                    placeholder="选择发布时间范围"
                    range
                    format="YYYY-MM-DD"
                    style="width:220px"
                    confirm
                ></DatePicker>
                <Input v-model="queryParams.name" placeholder="竞赛名称" style="width: 180px" />
                <Select v-model="tags" style="width:200px" multiple placeholder="请选择竞赛标签">
                    <Option :value="item.number" v-for="item in contestTypeList" >{{item.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 10px" @click="getList">查询</Button>
            </div>
            <Table  :columns="columns" :data="contestList.body"></Table>
            <div  class="page-box">
                <Page :total="contestList.page.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="contestList.page"/>
            </div>
        </div>

        <!-- 发布确认弹层-->
        <Modal
                v-model="publishModal"
                title="确认发布"
                loading
        >
            <Form :model="publishForm" ref="publishForm" :label-width="80" :rules="ruleValidate">
                <FormItem label="发布时间" prop="publishTime">
                    <DatePicker
                            type="date"
                            value-type="YYYY-MM-DD"
                            placeholder="选择发布时间范围"
                            range
                            v-model="publishForm.publishTime"
                            format="YYYY-MM-DD"
                            :disabled-date="noteBeforeTodayAndAfter"
                            confirm
                    ></DatePicker>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" size="large" @click="confirmPublish">确定</Button>
            </div>
        </Modal>
        <Modal
                title="是否确认发布?"
                v-model="confirmPublishModal"
        >
            <p style="color:red;">发布后将不能删除，或修改。 请再次确认是否要发布!</p>
            <div slot="footer">
                <Button type="primary" @click="confirmPublishModal=false">取消</Button>
                <Button type="default" @click="publish">确认</Button>
            </div>
        </Modal>
        <!--弹层结束-->

        <!--        选择公有云还是私有云-->
        <select-mcp ref="selectMcp" :returnMcp="create" ></select-mcp>

        <!--  删除-->
        <delete-modal ref="deleteModal" title="删除数据集" :callbackFunc="deleteOk" ></delete-modal>
    </div>
</template>
<style scoped lang="less">
    @import "../../style/index";
</style>
<script>
    import {mapActions,mapState} from 'vuex'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/zh-cn';
    import SelectMcp from '../common/selectMcp'
    import DeleteModal from '../common/deleteModal'
    import {authApi} from '@/api/base.js'
    import cookie from "vue-cookies";
    export default {
        name:'list',
        components:{
            DatePicker,
            SelectMcp,
            DeleteModal
        },
        computed:{
            ...mapState({
                contestList:state => state.contestAdminCommunity.contestList,
            })
        },
        data(){
            return {
                queryParams:{
                    name:'',
                    status:'',
                },
                contestTypeList:[],
                searchDate:"",
                tags:[],
                page_num:1,
                page_size:50,
                currentId:'',
                ruleValidate:{
                    publishTime: [
                        { required: true, type: 'array',min: 2,message: '发布时间必填', trigger: 'blur'},
                    ],
                },
                publishForm:{
                    publishTime:[],
                    id:'',
                },
                confirmPublishModal:false,
                publishModal:false,
                currentPage:"List",
                TableData:[],
                columns:[
                    {
                        title:'ID',
                        key:'id',
                        width:65,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title:'社区竞赛名称',
                        key:'name'
                    },
                    {
                        title:'开始时间',
                        key:'start_time'
                    },
                    {
                        title:'结束时间',
                        key:'end_time'
                    },
                    {
                        title:"标签",
                        key:'tags',
                        width:160,
                        render:(h,params)=>{
                            let name = "";
                            if(params.row.hasOwnProperty('tags')){
                                params.row.tags.forEach((item,k) =>{
                                    if(k == 0){
                                        name += item.name;
                                    }else{
                                        name += ","+item.name;
                                    }
                                })
                            }else{
                                name = "--";
                            }
                            return h('div',{},name)
                        },
                    },
                    {
                        title:'当前状态',
                        key:'proc_status_name',
                        width:120,
                    },
                    {
                        title:"导出状态",
                        key:'export_status',
                        width:150,
                        render:(h,params)=>{
                            let name = "--"
                            switch(params.row.export_status){
                                case 0:
                                    name = "--";
                                    break;
                                case 1:
                                    name = "未导出";
                                    break;
                                case 2:
                                    name = "正在导出";
                                    break;
                                case 3:
                                    name = "导出成功";
                                    break;
                                case 4:
                                    name = "导出失败-请重试";
                                    break;
                            }
                            return h('div',{},name)
                        }
                    },
                    {
                        title:'操作',
                        key:'action',
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                name: 'detailCommunity',
                                                query: {id: params.row.id},
                                            })
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.proc_status <= 3 ? 'inline-block' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                name:'editCommunity',
                                                query:{id:params.row.id}
                                            })
                                        }
                                    }
                                }, '编辑'),
                                h('a',{
                                    style:{
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.proc_status === 1 ? 'inline-block' : 'none'
                                    },
                                    on:{
                                        click:() => {
                                            this.publishModalShow(params.row.id);
                                        }
                                    }
                                },'发布'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.proc_status <= 2 ? 'inline-block' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.id);
                                        }
                                    }
                                }, '删除'),
                                h('a',{
                                    style:{
                                        marginRight:'5px',
                                        color:'#029ff6',
                                        display:params.row.proc_status == 4 ? 'inline-block':'none'
                                    },
                                    on:{
                                        click:() => {
                                            this.$router.push({
                                                name: 'correctCommunity',
                                                params: {id: params.row.id},
                                            })
                                        }
                                    }
                                },'阅卷'),
                                h('a',{
                                    style:{
                                        marginRight:'5px',
                                        color:'#029ff6',
                                        display:params.row.proc_status == 5 && (params.row.export_status == 0 || params.row.export_status==4 ) ? 'inline-block':'none'
                                    },
                                    on:{
                                        click:() => {
                                            this.export(params.row);
                                        }
                                    }
                                },'打包存档'),
                                h('a',{
                                    style:{
                                        marginRight:'5px',
                                        color:'#029ff6',
                                        display:params.row.export_status == 3 ? 'inline-block':'none'
                                    },
                                    on:{
                                        click:() => {
                                            // 新页面打开
                                            window.open(`${authApi}api-course/tm/ccompet/export/${params.row.id}/download?access_token=`+cookie.get('session'));
                                        }
                                    }
                                },'下载存档')
                            ])
                        }
                    }
                ],
            }
        },
        methods:{
            ...mapActions({
                deleteContest:'contestAdminCommunity/deleteContest',
                getContestList:'contestAdminCommunity/getContestList',
                publishContest:'contestAdminCommunity/publishContest',
                contestExport:'contestAdminCommunity/contestExport',
                getContestTypeList:'contestAdminCommunity/getContestTypeList',
            }),
            // 发起打包存档
            export(params){
                let _this = this;
                this.contestExport({
                    data:{
                        compet_id:params.id
                    },
                    callback:res=>{
                        _this.$Message.success("打包任务提交成功、请稍后下载！！");
                        _this.getList();
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
            // 获取竞赛标签
            get_contest_type_list(){
                this.getContestTypeList({
                    callback:res=>{
                        this.contestTypeList = res;
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                });
            },
            createConfirm(){
                this.$refs.selectMcp.isshow(true)
            },
            delete(id){
                this.currentId = id;
                this.$refs.deleteModal.isshow(true)
            },
            deleteOk(){
                this.deleteContest({
                    id:this.currentId,
                    callback:res=>{
                        this.$Message.success("删除成功");
                        this.getList();
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                })
            },
            change_page(page){
                this.page_num = page;
                this.getList();
            },
            noteBeforeTodayAndAfter(date){
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date <= (today - 86400);
            },
            publishModalShow(id){
                this.publishForm.publishTime = [];
                this.publishForm.id = id;
                this.publishModal = true;
            },
            confirmPublish(){
                // 验证
                this.$refs['publishForm'].validate((valid) => {
                    if (valid) {
                        this.confirmPublishModal = true;
                    } else {
                        this.$Message.error('请填写完整内容');
                    }
                })
            },
            create(mcpId){
                this.$router.push({
                    name: 'createCommunity',
                    params:{mcpid:mcpId}
                })
            },
            // 发布
            publish(){
                this.publishModal = false;
                this.confirmPublishModal = false;
                this.publishContest({
                    id:this.publishForm.id,
                    data:{
                        start_time:this.publishForm.publishTime[0],
                        end_time:this.publishForm.publishTime[1],
                    },
                    callback:res=>{
                        this.$Message.success("发布成功");
                        this.getList();
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                });
            },
            // 获取列表
            getList(){
                let _this = this;
                let data = {
                        page_num:_this.page_num,
                        page_size:_this.page_size,
                        name:_this.queryParams.name,
                        tags:_this.tags.toString(),
                        proc_status:_this.queryParams.status
                };
                if( this.searchDate != "" ){
                    data.start_time_begin = this.searchDate[0];
                    data.start_time_end = this.searchDate[1];
                }
                this.getContestList({
                    data:data,
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                })
            }
        },
        created(){
            this.getList();
            this.get_contest_type_list();
        },
    }
</script>